import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap'; // Form, Button, Card हटा दिया गया क्योंकि उनकी आवश्यकता नहीं है
import { useTranslation } from 'react-i18next';
import Loader from '../../components/Loader'; // सुनिश्चित करें कि यह पथ सही है

// useGetAboutUsQuery हुक को आयात करें
import { useGetAboutUsQuery } from '../../features/about/aboutUsApiSlice'; // सुनिश्चित करें कि यह पथ सही है

// यह फ़ंक्शन aboutUsData ऑब्जेक्ट से HTML स्ट्रिंग जेनरेट करेगा
const generateHtmlFromAboutUsData = (data, t) => {
  if (!data) return '<p>कोई About Us कंटेंट उपलब्ध नहीं है।</p>';

  let htmlContent = '';

  // मुख्य शीर्षक
  if (data.title) {
    htmlContent += `<h1 class="site-color-dark-red text-center mb-5 mt-5">${data.title}</h1>`;
  }

  // परिचय अनुभाग
  if (data.introduction) {
    htmlContent += `<p>${data.introduction}</p>`;
  }

  // मिशन और विजन अनुभाग
  if (data.missionAndVisionSection) {
    htmlContent += `<h2>${data.missionAndVisionSection.missionTitle || 'हमारा मिशन'}</h2>`;
    htmlContent += `<p>${data.missionAndVisionSection.missionStatement || ''}</p>`;
    htmlContent += `<h2>${data.missionAndVisionSection.visionTitle || 'हमारा विजन'}</h2>`;
    htmlContent += `<p>${data.missionAndVisionSection.visionStatement || ''}</p>`;
  }

  // इतिहास अनुभाग
  if (data.historySection) {
    htmlContent += `<h2>${data.historySection.title || 'हमारी यात्रा'}</h2>`;
    if (data.historySection.paragraphs && data.historySection.paragraphs.length > 0) {
      data.historySection.paragraphs.forEach(p => {
        htmlContent += `<p>${p}</p>`;
      });
    }
    if (data.historySection.milestones && data.historySection.milestones.length > 0) {
      htmlContent += '<h4>मुख्य पड़ाव:</h4><ul>';
      data.historySection.milestones.forEach(milestone => {
        htmlContent += `<li><strong>${milestone.year}:</strong> ${milestone.description}</li>`;
      });
      htmlContent += '</ul>';
    }
    if (data.historySection.historicalImages && data.historySection.historicalImages.length > 0) {
      data.historySection.historicalImages.forEach(imgSrc => {
        htmlContent += `<img src="${imgSrc}" alt="ऐतिहासिक छवि" style="max-width: 100%; height: auto; margin-bottom: 15px; border-radius: 8px;" />`;
      });
    }
  }

  // मूल्य अनुभाग
  if (data.valuesSection) {
    htmlContent += `<h2>${data.valuesSection.title || 'हमारे मूल्य'}</h2>`;
    if (data.valuesSection.valuesList && data.valuesSection.valuesList.length > 0) {
      htmlContent += '<ul>';
      // यहां valuesList ऑब्जेक्ट्स का एक array है, इसलिए value.name और value.description का उपयोग करें
      data.valuesSection.valuesList.forEach(value => {
        htmlContent += `<li><strong>${value.name}:</strong> ${value.description}</li>`;
      });
      htmlContent += '</ul>';
    }
  }

  // प्रभाव और उपलब्धियां अनुभाग
  if (data.impactAndAchievementsSection) {
    htmlContent += `<h2>${data.impactAndAchievementsSection.title || 'प्रभाव और उपलब्धियां'}</h2>`;
    if (data.impactAndAchievementsSection.achievementsList && data.impactAndAchievementsSection.achievementsList.length > 0) {
      htmlContent += '<h3>उपलब्धियां:</h3><ul>';
      data.impactAndAchievementsSection.achievementsList.forEach(achievement => {
        htmlContent += `<li>${achievement}</li>`;
      });
      htmlContent += '</ul>';
    }
    // impactMetrics (आपके JSON में खाली है, लेकिन अगर डेटा होता तो यहां रेंडर होता)
    if (data.impactAndAchievementsSection.impactMetrics && data.impactAndAchievementsSection.impactMetrics.length > 0) {
        htmlContent += '<h3>प्रभाव मेट्रिक्स:</h3><ul>';
        data.impactAndAchievementsSection.impactMetrics.forEach(metric => {
            htmlContent += `<li><strong>${metric.name}:</strong> ${metric.value}</li>`;
        });
        htmlContent += '</ul>';
    }
    if (data.impactAndAchievementsSection.testimonials && data.impactAndAchievementsSection.testimonials.length > 0) {
        htmlContent += '<h3>प्रशंसापत्र:</h3>';
        data.impactAndAchievementsSection.testimonials.forEach(testimonial => {
            htmlContent += `<blockquote style="border-left: 4px solid #ccc; margin: 1.5em 10px; padding: 0.5em 10px;">
                                <p>"${testimonial.quote}"</p>
                                <footer style="text-align: right;">- ${testimonial.author}</footer>
                            </blockquote>`;
        });
    }
  }

  // नेतृत्व टीम अनुभाग (यदि सदस्य हैं)
  if (data.leadershipSection && data.leadershipSection.members && data.leadershipSection.members.length > 0) {
    htmlContent += `<h2>${data.leadershipSection.title || 'नेतृत्व टीम'}</h2>`;
    data.leadershipSection.members.forEach(member => {
      htmlContent += `
        <div style="display: flex; align-items: center; margin-bottom: 20px;">
          <img src="${member.image || 'https://placehold.co/100x100'}" alt="${member.name}" style="border-radius: 50%; width: 80px; height: 80px; object-fit: cover; margin-right: 15px;" />
          <div>
            <h3>${member.name}</h3>
            <p><em>${member.position}</em></p>
            <p>${member.bio}</p>
          </div>
        </div>
      `;
    });
  }

  // अतिरिक्त छवियां
  if (data.additionalImages && data.additionalImages.length > 0) {
    htmlContent += '<h3>गैलरी:</h3><div style="display: flex; flex-wrap: wrap; gap: 15px; justify-content: center;">';
    data.additionalImages.forEach(imgSrc => {
      htmlContent += `<img src="${imgSrc}" alt="अतिरिक्त छवि" style="max-width: 100%; width: 350px; height: auto; border-radius: 8px; object-fit: cover;" />`;
    });
    htmlContent += '</div>';
  }

  // कॉल टू एक्शन
  if (data.callToAction) {
    htmlContent += `
      <div style="text-align: center; margin-top: 30px; padding: 20px; background-color: #f0f0f0; border-radius: 8px;">
        <p style="font-size: 1.2em; font-weight: bold;">${data.callToAction.text}</p>
        <a href="${data.callToAction.link}" style="display: inline-block; background-color: #007bff; color: white; padding: 10px 20px; text-decoration: none; border-radius: 5px; margin-top: 10px;">
          ${data.callToAction.buttonText}
        </a>
      </div>
    `;
  }

  // संपर्क जानकारी
  if (data.contactInfo) {
    htmlContent += `<h2>${data.contactInfo.title || 'हमसे संपर्क करें'}</h2>`;
    htmlContent += `<p><strong>पता:</strong> ${data.contactInfo.address}</p>`;
    htmlContent += `<p><strong>ईमेल:</strong> <a href="mailto:${data.contactInfo.email}">${data.contactInfo.email}</a></p>`;
    htmlContent += `<p><strong>फ़ोन:</strong> <a href="tel:${data.contactInfo.phone}">${data.contactInfo.phone}</a></p>`;
    htmlContent += `<p><strong>वेबसाइट:</strong> <a href="${data.contactInfo.website}" target="_blank" rel="noopener noreferrer">${data.contactInfo.website}</a></p>`;
  }

  // संबंधित लिंक
  if (data.relatedLinks && data.relatedLinks.length > 0) {
    htmlContent += '<h2>संबंधित लिंक:</h2><ul>';
    data.relatedLinks.forEach(link => {
      htmlContent += `<li><a href="${link.url}" target="_blank" rel="noopener noreferrer">${link.text}</a></li>`;
    });
    htmlContent += '</ul>';
  }

  return htmlContent;
};

const Index = () => {
  const { t } = useTranslation();
  const [localLoading, setLocalLoading] = useState(true);

  const {
    data: aboutUsData,
    isLoading,
    isSuccess,
    isError,
    error
  } = useGetAboutUsQuery();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLocalLoading(false);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  if (localLoading || isLoading) {
    return <Loader />;
  }

  if (isError) {
    console.error("About Us डेटा फ़ेच करने में त्रुटि:", error);
    return (
      <div className='mainContainer'>
        <Container>
          <Row className="justify-content-md-center mt-5">
            <Col xs={12} md={12} className="text-center">
              <h1 className='site-color-dark-red mb-3'>त्रुटि</h1>
              <p className="text-danger">About Us डेटा लोड करने में त्रुटि हुई। कृपया बाद में पुनः प्रयास करें।</p>
              <p className="text-muted">त्रुटि संदेश: {error.message || JSON.stringify(error)}</p>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className='mainContainer'>
      <div className='innerBanner'>
        <img src={require('../../assets/images/banner/banner-1.JPG')} alt="Event" />
        <div className='innerBannerWrap non-event'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-6'>
                <div className='banner-item-wrap'>
                  <h1 className=''></h1>
                  <p className='h3'><em>"ब्रह्म ज्ञान की धर्म ध्वजा को जग में है लहराना"</em></p>
                  <h1 className=''>&nbsp;</h1>
                  <p className='h3'><em>" We have to hoist the religious flag of Brahma Gyan in the world "</em></p>
                  <p className='h5'>~ Dheer Singh</p>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='banner-item-wrap'>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Container>
        <p>Home / About</p>
        <Row className="justify-content-md-center">
          <Col xs={12} md={12}>
            {/* यह शीर्षक अब generateHtmlFromAboutUsData फ़ंक्शन के अंदर से आएगा */}
            {/* <h1 className='site-color-dark-red text-center mb-5 mt-5'>{t('aboutUs.title')}</h1> */}
          </Col>
          <Col xs={12} md={7}>
            <div className='about-content'>
              {/* RTK Query से प्राप्त डेटा को यहां प्रदर्शित करें */}
              {isSuccess && aboutUsData ? (
                <div dangerouslySetInnerHTML={{ __html: generateHtmlFromAboutUsData(aboutUsData.data, t) }}></div>
              ) : (
                <p>About Us कंटेंट लोड हो रहा है...</p>
              )}
            </div>
          </Col>
          <Col xs={12} md={5}>
            <div className='about-image'>
              <img className='full-width' alt='image' src={require('../../assets/images/about.jpg')} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Index;
